import React, { useEffect, useState, useRef } from "react";
import Draggable from "react-draggable";
import "./elementModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import CustomTooltip from "../../../../Elements/Tooltip";

const ElementModal = ({
  heading,
  children,
  footer,
  openModal,
  handleCloseModal,
  z_index,
  modalWidth,
  headerErrors,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    setIsOpen(openModal);
    setTimeout(() => {
      setIsAnimating(true);
    }, 10);
    return () => {
      setIsOpen(false);
      setIsAnimating(true);
    };
  }, [openModal]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && openModal) {
        // Modal is hidden (not closed) while the colour-picker eyedropper is
        // sampling — let that Escape just cancel the pick, not close us too.
        if (modalRef.current?.style.visibility === "hidden") return;
        setTimeout(() => {
          setIsOpen(false);
          handleCloseModal(false);
          const divToRemove = document.getElementById("createdDivId");
          if (divToRemove) {
            divToRemove.remove();
          }
        }, 300);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [openModal]);

  const closeModal = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsOpen(false);
      handleCloseModal(false);
    }, 300);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("Background");
    } else {
      document.body.classList.remove("Background");
    }
    return () => {
      document.body.classList.remove("Background");
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <Draggable axis="x" handle=".handle-drag" position={null}>
          <div
            ref={modalRef}
            className={` elementModal ${isAnimating ? "fade-in" : "fade-out"}`}
            style={{ zIndex: z_index ?? "1002" }}
          >
            <div
              className={`elementModal-content ${isAnimating ? "slide-in" : "slide-out"
                }`}
              style={{ width: modalWidth ?? "618px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="handle-drag">
                <div className="elementModal-header">
                  <div className={`heading ${modalWidth ? "text-dark" : ""}`}>
                    {heading}
                    {headerErrors?.length > 0 && (
                      <CustomTooltip
                        placement="bottom"
                        title={
                          <div className="elem-modal-header-errors">
                            {headerErrors.map((e, i) => (
                              <div key={i} className="elem-modal-header-error-item">
                                <strong>{e.section}:</strong> {e.error}
                              </div>
                            ))}
                          </div>
                        }
                      >
                        <span className="elem-modal-header-warning">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                            <line x1="12" y1="9" x2="12" y2="13" />
                            <line x1="12" y1="17" x2="12.01" y2="17" />
                          </svg>
                        </span>
                      </CustomTooltip>
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faArrowsUpDownLeftRight}
                      className={`elementModal-action-btn ${modalWidth ? "text-dark" : ""
                        }`}
                    />
                    <div className="spacer" />
                    <FontAwesomeIcon
                      icon={faXmark}
                      className={`elementModal-action-btn cursor-pointer ${modalWidth ? "text-dark" : ""
                        }`}
                      onClick={() => closeModal()}
                    />
                  </div>
                </div>
              </div>
              <div className="elementModal-body">
                {children}
              </div>
              {footer && <div className="elementModal-footer">{footer}</div>}
            </div>
          </div>
        </Draggable>
      )}
    </>
  );
};

export default ElementModal;
